import React, { useEffect, useState } from "react";
import BackBtn from "../images/backButton.svg";
import locImg from "../images/location.svg";
import { Link, useNavigate } from "react-router-dom";
import Alert from "./alert/Alert";
import ToolTip from "./walk-through/ToolTip";


function HomeHeader(props) {
  const navigate = useNavigate();

  const [showAlert, setShowAlert] = useState(false);
 

  const backToHotels = () => {
    localStorage.removeItem("restrictHotelListFlag");
    localStorage.removeItem("restrictHomePageFlag");
    navigate("../hotel-list");
  };

  const walkThroughFlag = localStorage.getItem("RestrictWalkThroughInHistory");

  const historyDescription = "Your Order History/ Status will display here";
  const [showHistoryToolTip, setShowHistoryToolTip] = useState(false);
  // Variable to store the timeout
  let debounceTimeout = null; 

  const hideHistoryTooltip = () => {
    setShowHistoryToolTip(false);
    localStorage.setItem("RestrictWalkThroughInHistory", 1);

  };

  const showToolTips = () => {
    setTimeout(() => {
      setShowHistoryToolTip(true);
    }, 1000);
  };

  useEffect(() => {
    if (!walkThroughFlag) showToolTips();
  }, []);

  // useEffect(() => {
  //   const handlePopState = (event) => {
  //     clearTimeout(debounceTimeout);
  //     debounceTimeout = setTimeout(() => {
  //      setShowAlert(true)
  //     }, 100); 
  //   };

  //   window.history.pushState(null, null);

  //   window.addEventListener('popstate', handlePopState);

  //   return () => {
  //     window.removeEventListener('popstate', handlePopState);
  //     clearTimeout(debounceTimeout); 
  //   };
  // }, []);



  return (
    <div className="home-header">
      {props.hotelDetails && (
        <div className="hotel-detail flex section-wrap ">
          <div
            onClick={() => setShowAlert(true)}
            className="h-fit mt-2 cursor-pointer"
          >
            <img src={BackBtn} alt="" />
          </div>

          <div className="flex flex-col gap-1 ml-3">
            <div className="flex items-center gap-4">
            <div className="hotel-name truncate w-[135px]">{props.hotelDetails.hotelName}</div>
            {!props.checkOuted && props.reservationDetails.checkedIn &&<div className="checkin-status">Checked-in</div>}
            {!props.checkOuted  && !props.reservationDetails.checkedIn && <div className="not-checkin-status">Not Checked-in</div>}
            { props.checkOuted && <div className="checkedout-status">Checked-out</div>}
            </div>
            {props.hotelDetails.city && (
              <div className="location  mb-2 truncate w-[135px]">
              {props.hotelDetails.city} , {props.hotelDetails.state}
              </div>
            )}
          </div>
        </div>
      )}
      {props.reservationDetails && (
        <div className="reservation">
          <div className="section-wrap  w-1/2 flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="label">Your Booking-ID</div>
              <div className="bId">{props.reservationDetails.bookingId}</div>
            </div>
            {/* <div className="divider"></div> */}
            {/* <div className="flex flex-col gap-">
            <div className="label">Check-out</div>
            <div>
              <span className="bId"> {props.reservationDetails.dateOut}</span>
            </div>
          </div> */}
            {/* <div className="request-early" onClick={props.showEarly}>Request Early Check-in</div> */}
            {/* early chekkin */}
            <div className="relative">
              <button onClick={() => navigate('/order-history')}  className="order-history" >
              Order History / Status 
              </button>
              {showHistoryToolTip && (
                <ToolTip
                  position="bottom-left"
                  description={historyDescription}
                  arrowPosition="top"
                  confirmBtn="ok"
                  source="history"
                  hideHistoryTooltip={hideHistoryTooltip}
                />
              )}
            </div>
          </div>
        </div>
      )}
      {showAlert && (
        <Alert
          closeHotel={backToHotels}
          hideModal={() => setShowAlert(false)}
        />
      )}
    </div>
  );
}

export default HomeHeader;
